import React, {useLayoutEffect} from "react";
import {createBrowserRouter, Navigate, RouterProvider, useLocation} from "react-router-dom";

import {AppProviders} from "./AppProviders";
import {getClientRoot} from "./react-root";
import Services, {IndustriesDirectory, LocationsDirectory} from "@fig/client/routes/Services/Services";

function ServicesScrollManager() {
  const {pathname, hash} = useLocation();

  useLayoutEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      if (!hash) {
        window.scrollTo({top: 0, left: 0, behavior: "auto"});
        return;
      }

      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      target?.scrollIntoView({block: "start", inline: "nearest", behavior: "auto"});
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
}

function ServicesRoute({children}: {children: React.ReactElement}) {
  return (
    <>
      <ServicesScrollManager />
      {children}
    </>
  );
}

function Root() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <ServicesRoute>
          <Services />
        </ServicesRoute>
      ),
    },
    {
      path: "/offices/:officeSlug",
      element: (
        <ServicesRoute>
          <Services />
        </ServicesRoute>
      ),
    },
    {
      path: "/locations",
      element: (
        <ServicesRoute>
          <LocationsDirectory />
        </ServicesRoute>
      ),
    },
    {
      path: "/locations/:locationSlug",
      element: (
        <ServicesRoute>
          <Services />
        </ServicesRoute>
      ),
    },
    {
      path: "/industries",
      element: (
        <ServicesRoute>
          <IndustriesDirectory />
        </ServicesRoute>
      ),
    },
    {
      path: "/industries/:industrySlug",
      element: (
        <ServicesRoute>
          <Services />
        </ServicesRoute>
      ),
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);

  return <RouterProvider router={router} />;
}

const root = getClientRoot();

root.render(
  <AppProviders>
    <Root />
  </AppProviders>,
);

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept();
}
